import { GET_ALL_PLANS_SAGA } from "../constants/PlansConstant";

export const getAllPlans = () => ({
    type: GET_ALL_PLANS_SAGA,
})
